import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainLayout from "./Layout/MainLayout";
import Testimonials from "./components/Testimonials/Testimonials";
import Sitemap from "./components/Sitemap/Sitemap";

const App = (props) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainLayout />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/sitemap" element={<Sitemap />} />
      </Routes>
    </BrowserRouter>
  );
};

App.propTypes = {};

export default App;
